<!-- start banner Area -->
<section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                                background-size: cover;" id="home-section">
  <div class="container" style="padding: 100px 0px 100px 0px;">
    <div class="row">
      <div class="col-md-10">
        <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Réinitialiser le mot de passe
        </h1>

        <div class="custom-breadcrumbs">
          <a style=" color: #FF5A00 " href="/connexion">Connexion</a> <span class="mx-2 slash">/</span>
          <span class="text-white"><strong>Réinitialiser le mot de passe</strong></span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap mt-3" id="service">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <form class="col-md-6 pb-40 form-area" [formGroup]="form" (ngSubmit)="onSubmitForm()">
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" style="text-transform: lowercase !important;" class="form-control" id="email"
            formControlName="email">
        </div>
        <button type="submit" class="primary-btn text-white mb-4" [disabled]="form.invalid"
          *ngIf="!isLoading">Réinitialiser</button>
        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez patienter...</p>
        <div class="form-group" *ngIf="typeUser == 'candidat'">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="typeUser == 'consultant'">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="typeUser == 'entreprise'">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="typeUser == 'admin'">
          <label>Retour à la page de <a [routerLink]="['/admin', '']">connexion</a></label>
        </div>
      </form>
    </div>
  </div>
</section>
<!-- End service Area -->